import {useGetInfiniteSpecialists} from '@/features/projects/specialists/queries/useGetInfiniteSpecialists'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'

interface UseSpecialistsListProps {
    limit?: number
    search?: string
    enabled?: boolean
}

export const useSpecialistsList = ({limit = 10, search, enabled}: UseSpecialistsListProps) => {
    const query = useGetInfiniteSpecialists({
        params: {
            page: 1,
            limit,
            search
        },
        options: {enabled}
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        specialists: query.data?.pages.flatMap(page => page.data) ?? []
    }
}
